import { ArrowLeft } from "lucide-react";
import { useNavigate, useParams } from "react-router";

import { Button } from "@/components/ui/button";
import { useMe } from "@/hooks/use-auth";
import { useWorkspaceBonusRules, useWorkspaces } from "@/hooks/use-workspaces";

import { BonusRulesForm } from "./bonus-rules-form";

export function BonusRulesPage({
  workspaceIdOverride,
  backUrl,
}: {
  workspaceIdOverride?: string;
  backUrl?: string;
} = {}) {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data: me } = useMe();
  const workspaceId = workspaceIdOverride ?? id ?? me?.activeWorkspaceId ?? "";

  const { data: workspacesData } = useWorkspaces({ per_page: 100 });
  const workspace =
    workspacesData?.items.find((w) => w.id === workspaceId) ?? null;

  const { data: existingRules, isLoading } =
    useWorkspaceBonusRules(workspaceId);

  function goBack() {
    if (backUrl) {
      navigate(backUrl);
    } else if (id) {
      navigate("/settings/workspaces");
    } else {
      navigate("/settings/workspace");
    }
  }

  return (
    <div>
      <div className="mb-6 flex items-center gap-3">
        <Button variant="ghost" size="icon" onClick={goBack}>
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <div>
          <h1 className="text-xl font-semibold">Gaji & Bonus Rider</h1>
          <p className="text-sm text-muted-foreground">
            Atur gaji harian, tarif pendapatan penjualan, dan target bonus
            kategori untuk workspace{" "}
            <span className="font-medium text-foreground">
              {workspace?.name ?? "..."}
            </span>
            .
          </p>
        </div>
      </div>

      {isLoading || !workspace ? (
        <div className="py-8 text-center text-sm text-muted-foreground">
          Memuat aturan bonus...
        </div>
      ) : (
        <BonusRulesForm
          key={`${workspace.id}-${existingRules?.length ?? 0}`}
          workspace={workspace}
          initialRules={existingRules}
          onSaved={goBack}
        />
      )}
    </div>
  );
}
